<template>
    <div>
        <div class="tabs">
            <div class="tab-list">
                <div class="tab-list-item" v-for="tab in tabs" :key="`tab-li-${tab.id}`" :class="tab.style">
                    <a :href="tab.href" @click="selectTab(tab)" v-text="tab.name"></a>
                </div>
            </div>
        </div>

        <div class="tabs-details">
            <slot></slot>
        </div>
    </div>
</template>
<script>
export default {

    data() {
        return {
            tabs: [],
            slick: null,
        };
    },


    created() {
        eventBus.$on('schedule-updated', this.reloadSlick)
        eventBus.$on('select-tab', this.selectTab)
        this.tabs = this.$children;
    },

    mounted() {
        this.reloadSlick();
    },

    methods: {

        addDates() {
            eventBus.$emit('open-add-dates-to-list-dialog')
        },

        selectTab(selectedTab) {
            let previousTab = this.findCurrentTab()
            this.tabs.forEach(tab => {
                tab.isActive = (tab.id == selectedTab.id);
            });
            this.$emit('onClick', {
                previous: previousTab,
                current: selectedTab
            })
        },

        reloadSlick() {
            if (this.slick) {
                this.tabs = [];
                this.tabs = this.$children;
                $('.tab-list').slick('unslick')
                this.slick = null;
            }
            this.$nextTick(() => {
                this.slick = $('.tab-list')
                    .not('.slick-initialized')
                    .slick({
                        infinite: false,
                        arrows: true,
                        slidesToShow: 5,
                        slidesToScroll: 5,
                        variableWidth: true,
                        centerPadding: '5px',
                        prevArrow: '<span class="slick-prev slick-arrow"><svg class="arrow-right"><use xlink:href="#arrow-right"></use></svg></span>',
                        nextArrow: '<span class="slick-next slick-arrow"><svg class="arrow-right"><use xlink:href="#arrow-right"></use></svg></span>',
                        responsive: [
                            {
                                breakpoint: 1500,
                                settings: {
                                    slidesToShow: 5,
                                    slidesToScroll: 5,
                                }
                            },
                            {
                                breakpoint: 1300,
                                settings: {
                                    slidesToShow: 5,
                                    slidesToScroll: 5,
                                }
                            },
                            {
                                breakpoint: 1100,
                                settings: {
                                    slidesToShow: 6,
                                    slidesToScroll: 6,
                                }
                            },
                            {
                                breakpoint: 900,
                                settings: {
                                    slidesToShow: 5,
                                    slidesToScroll: 5,
                                }
                            },
                            {
                                breakpoint: 800,
                                settings: {
                                    arrows: false,
                                    prevArrow: null,
                                    nextArrow: null,
                                    slidesToShow: 7,
                                    slidesToScroll: 7,
                                    centerPadding: '2px',
                                }
                            },
                            {
                                breakpoint: 480,
                                settings: {
                                    arrows: false,
                                    prevArrow: null,
                                    nextArrow: null,
                                    slidesToShow: 5,
                                    slidesToScroll: 5,
                                }
                            }
                        ]
                    });
            })
        },

        findCurrentTab() {
            return _.find(this.tabs, t => t.isActive)
        }
    }
}
</script>
